import { Modal } from 'react-bootstrap'
import ComponentePrivado from '../../../../components/roles/ComponentePrivado'
import { Roles } from '../../../../utils/Roles'

type Props = {
  isLoadingActualizar: boolean
  isLoadingGuardar: boolean
  isLoadingGuardarReportes: boolean
  isModoEditar:boolean
  usuarioPermiso?: boolean
  cerrarModal:()=>void
  focusErrorForm:()=>void
  
}

export const ModalCondicionanteFooter = ({
  isLoadingActualizar,
  isLoadingGuardar,
  isLoadingGuardarReportes,
  usuarioPermiso,
  isModoEditar,
  cerrarModal,
  focusErrorForm,
  
}: Props) => {
  // Footer: en modo lectura el boton es "Cerrar"; si hay permiso, habilita submit.
  return (
    <Modal.Footer>
      <div className='overlay overlay-block overlay-wrapper overlay-layer'>
        <button
          type='reset'
          className=' btn  text-hover-dark btn-cancelar'
          onClick={cerrarModal}
          disabled={isLoadingActualizar || isLoadingGuardar || isLoadingGuardarReportes}>
          {usuarioPermiso ? 'Cancelar' : 'Cerrar'}
        </button>
        <ComponentePrivado rolMostrarPorPermiso={[Roles.roleCondicionantesCrear]}>
          <button
            onClick={() => {
              focusErrorForm()
            }}
            className='btn btn-primary p-3'
            form='form-condicionante'
            type='submit'
            disabled={isLoadingActualizar || isLoadingGuardar || isLoadingGuardarReportes}>
            {isModoEditar ? 'Actualizar condicionante' : 'Guardar condicionante'}
          </button>
        </ComponentePrivado>
      </div>
    </Modal.Footer>
  )
}
